export const CaptchaConfig = {
  siteKey: '0x4AAAAAADnmPH3Ch3zGeVfo',
  errorPopupText: 'Please complete the safety verification.'
};
